import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    menus: [ "Main", "About Server", "About us" ]
}

const menuSlice = createSlice({
    name: "menu",
    initialState,
    reducer: {}
})

export const selectMenus = state => state.menu.menus

export default menuSlice.reducer